(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[32043],{

/***/ 78921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _BreadCrumb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3605);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _LoaderRemote__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71593);
/* harmony import */ var _BlogList_Sidebar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69897);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _styles_BlogDetail_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(500);
/* harmony import */ var _styles_BlogDetail_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_BlogDetail_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73040);










var BlogDetail = function(param) {
    var ssr = param.ssr, isAppWebView = param.isAppWebView;
    var blogPage = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .m)().blogPage;
    var page = ssr.result;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var SearchOnSubmit = function(SearchText) {
        var query = router.query;
        query.slug = [
            blogPage.url
        ];
        if (SearchText) {
            query.search = SearchText;
        } else {
            delete query.search;
        }
        router.replace({
            query: query
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BreadCrumb__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                data: ssr.result.BreadCrumb,
                isAppWebView: isAppWebView
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "Blog_detail",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "grid grid-cols-12 gap-x-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "lg:col-span-8 col-span-12",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "item-img mb-4 relative",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full h-96 rounded-lg relative",
                                            children: page.resim && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                loader: _LoaderRemote__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
                                                src: page.resim,
                                                layout: "fill",
                                                objectFit: "cover",
                                                objectPosition: "center",
                                                alt: page.title
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "inc-header",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex flex-row items-center pb-2"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-25 font-semibold mb-3",
                                                children: page.baslik
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-normal text-15 " + (_styles_BlogDetail_module_css__WEBPACK_IMPORTED_MODULE_8___default().Content),
                                                dangerouslySetInnerHTML: {
                                                    __html: page.icerik
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BlogList_Sidebar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                SearchOnSubmit: SearchOnSubmit,
                                LastShared: page.LastShared,
                                Popular: page.Popular
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BlogDetail);


/***/ }),

/***/ 500:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Content":"BlogDetail_Content__C7riv"};

/***/ })

}]);